var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3501 39C10.6516 39 3.6001 31.8366 3.6001 23C3.6001 14.1634 10.6516 7 19.3501 7C25.4037 7 30.6597 10.4695 33.2963 15.5579C33.5455 15.5416 33.7968 15.5333 34.0501 15.5333C40.429 15.5333 45.6001 20.7865 45.6001 27.2667C45.6001 33.7468 40.429 39 34.0501 39C28.6919 39 24.8571 39 19.3501 39Z",
    stroke: "#83F279",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3188 31.4587V30.4019L35.3371 28.7474C36.0907 28.1238 36.3852 27.7946 36.3852 27.2922C36.3852 26.7812 36.0474 26.504 35.571 26.504C35.1032 26.504 34.7827 26.7638 34.3323 27.3182L33.3968 26.5646C33.9945 25.7504 34.5749 25.3086 35.6576 25.3086C36.9136 25.3086 37.7452 26.0449 37.7452 27.1969C37.7452 28.2104 37.2255 28.7128 36.1514 29.5444L35.1639 30.3066H37.8058V31.4587H33.3188Z",
    fill: "#83F279",
    stroke: "#83F279",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8954 30.1886C23.7915 30.1886 21.626 27.8354 21.626 24.9625C21.626 22.1184 23.8204 19.7363 26.9243 19.7363C30.0282 19.7363 32.1937 22.0895 32.1937 24.9625C32.1937 27.8065 29.9993 30.1886 26.8954 30.1886ZM26.9243 28.5572C28.931 28.5572 30.3314 26.9547 30.3314 24.9625C30.3314 22.9991 28.9021 21.3677 26.8954 21.3677C24.8887 21.3677 23.4883 22.9702 23.4883 24.9625C23.4883 26.9259 24.9176 28.5572 26.9243 28.5572Z",
    fill: "#83F279",
    stroke: "#83F279",
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5326 30.1886C13.5875 30.1886 11.3931 27.8931 11.3931 24.9625C11.3931 22.0895 13.5442 19.7363 16.6048 19.7363C18.4671 19.7363 19.5932 20.386 20.5605 21.3099L19.4199 22.6237C18.6115 21.873 17.7453 21.3677 16.5903 21.3677C14.6558 21.3677 13.2554 22.9557 13.2554 24.9625C13.2554 26.9403 14.6558 28.5572 16.5903 28.5572C17.8319 28.5572 18.6259 28.0519 19.4921 27.2435L20.6326 28.3984C19.5788 29.4956 18.4238 30.1886 16.5326 30.1886Z",
    fill: "#83F279",
    stroke: "#83F279",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.7541109dea824d955331c5d4ef7fa661.svg";
export { ForwardRef as ReactComponent };